import { Account } from '../model/account';
import Pojo from '../model/pojo';
import { ApiCrud } from './api-crud';
import http from './http';

const accountApi = new ApiCrud(http.AXIOS, Account, 'accounts');

accountApi.add({
  accountAll: '/accounts',
  account: '/accounts/:id',

  // get accounts by user id
  // TODO: this API should be modified to use a filter param in the above call
  userAccount: 'GET /accounts/user/:id',
  userManagedAccount: ' GET /accounts/managed/:id',

  // Get list of roles. This supercedes the old JWT-based role map
  userAccountRoles: 'GET /accounts/user/:id/roles',
  dropdownUsers: ['GET /accounts/{accountId}/dropdownUsers', { model: Pojo }],
  userAccountRolesAll: 'GET userAccountRoles',

  mapUsersAndDropdowns: 'PUT /accounts/{accountId}/mapUsersAndDropdowns',
  removeUserFromDropdown: 'DELETE /accounts/{accountId}/dropdown/{id}',
  provisionDefaultAccountData: 'PUT /accounts/{accountId}/provisionDefaultAccountData',
  mapUsers: 'PUT /accounts/{accountId}/mapUsers',
  removeUser: 'DELETE /accounts/{accountId}/removeUser',
});

export default accountApi;
